import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { EndpointBuilder } from "@reduxjs/toolkit/query/react";

import type { AddressStored, PreparedProfileType } from "@jti/fe-common";

import type { TAGS } from "./common/tags";

export type ProfileApiBuilder = EndpointBuilder<BaseQueryFn, typeof TAGS.PROFILE, "profileApi">;

export type GetProfileQueryData = Omit<PreparedProfileType, "addresses"> & {
  addresses?: AddressStored[];
};
